import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("a", {
    value: "value",
    class: "uix-icon show",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onIconClick()))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.value)
    }, null, 2)
  ], 512)), [
    [_vShow, _ctx.value]
  ])
}